var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFluvialFlood({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fit: "",
    preserveAspectRatio: "xMidYMid meet",
    focusable: "false",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.083 17.5c3.714 0 4.722 1.901 8.694 1.901 2.648 0 4.722-.464 6.223-1.393v2.537c-1.869.97-3.943 1.455-6.223 1.455-3.42 0-4.994-1.962-8.628-1.962-2.424 0-4.14.316-5.149.948v-2.538c.913-.632 2.608-.948 5.083-.948zM11.141 2l3.04 3.245V3.968c0-.474.506-.71 1.52-.71.945 0 1.463.206 1.555.618l.013.092v4.344l.997.935c.49.362.734.85.734 1.465 0 .553-.126.937-.378 1.153l-.09.066H17.27l.002 2.907c1.857-.15 3.434-.594 4.729-1.33v2.535c-1.869.971-3.943 1.457-6.223 1.457-3.42 0-4.791-1.964-8.628-1.964-2.559 0-4.275.316-5.149.947v-2.535c.742-.514 2-.819 3.774-.915l.001-1.102h-1.01c-.407 0-.765-.428-.765-1.22 0-.435.115-.783.346-1.042l.105-.106L11.141 2zm1.676 10.323h-2.29a1 1 0 0 0-.994.883l-.004.104c1.34.351 2.397.92 3.752 1.274a.998.998 0 0 0 .53-.769l.006-.117v-.375a1 1 0 0 0-1-1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluvialFlood);
export default __webpack_public_path__ + "static/media/fluvial_flood.3021693b8e848eff40cfa36d80a9e408.svg";
export { ForwardRef as ReactComponent };